import React from 'react';

// React error boundary wrapped around every widget mount in LayoutRenderer.
// One broken widget renders a "Widget unavailable" placeholder instead of
// crashing the whole layout, and the throw is logged to the console for
// developer-mode debugging. (Server-side AuditLog reporting via a
// /api/client-errors endpoint is wired in L4 alongside Script Widget logging.)

const containerStyle = {
  border: '1px dashed #ef444450',
  background: '#ef444410',
  color: '#ef4444',
  padding: '12px',
  borderRadius: '6px',
  fontSize: '12px',
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
};

class WidgetErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null, expanded: false };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    if (typeof console !== 'undefined') {
      console.error(`[layout] widget "${this.props.widgetType}" threw:`, error, info);
    }
  }

  reset = () => this.setState({ error: null, info: null, expanded: false });
  toggle = () => this.setState(s => ({ expanded: !s.expanded }));

  render() {
    if (!this.state.error) return this.props.children;
    const { widgetType, paletteLabel } = this.props;
    return (
      <div style={containerStyle} role="alert">
        <div style={{ fontWeight: 600 }}>
          ⚠ {paletteLabel || widgetType || 'Widget'} unavailable
        </div>
        <div style={{ color: 'var(--text-secondary)' }}>
          This widget failed to render. The rest of the layout is unaffected.
        </div>
        <div style={{ display: 'flex', gap: '8px' }}>
          <button
            onClick={this.reset}
            style={{ background: 'transparent', border: '1px solid #ef444450', color: '#ef4444', padding: '3px 8px', borderRadius: '4px', fontSize: '11px', cursor: 'pointer' }}
          >Retry</button>
          <button
            onClick={this.toggle}
            style={{ background: 'transparent', border: '1px solid #ef444450', color: '#ef4444', padding: '3px 8px', borderRadius: '4px', fontSize: '11px', cursor: 'pointer' }}
          >{this.state.expanded ? 'Hide' : 'View'} error</button>
        </div>
        {this.state.expanded && (
          <pre style={{ margin: 0, fontSize: '11px', whiteSpace: 'pre-wrap', overflowX: 'auto', color: 'var(--text-secondary)' }}>
            {String(this.state.error?.stack || this.state.error?.message || this.state.error)}
          </pre>
        )}
      </div>
    );
  }
}

export default WidgetErrorBoundary;
